module.exports = __webpack_public_path__ + "static/media/check-email-icon.a94768b4.svg";